define('lq/events/actions/chatGPTImageCommand',[
    'lq/events/actions/eventAction'
], function(EventAction) {
    'use strict';
    
    function ChatGPTImageCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(ChatGPTImageCommand, EventAction);

    ChatGPTImageCommand.typeName = 'ChatGPTImageCommand';

    ChatGPTImageCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ChatGPTImageCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'ChatGPTImage',
            command: this.eventData.command
        };
    };

    return ChatGPTImageCommand;
});

